import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: "users",
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },

    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
      },
    },

    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/User.vue'),
      meta: {
        pageTitle: 'Người dùng',
        breadcrumb: [
          {
            text: 'Danh sách',
            active: true,
          },
        ],
      },
    },

    {
      path: '/transaction/deposit',
      name: 'transaction-deposit',
      component: () => import('@/views/Transaction/Deposit.vue'),
      props: { type: "deposit" },
      meta: {
        pageTitle: 'Nạp tiền',
        breadcrumb: [
          {
            text: 'Danh sách',
            active: true,
          },
        ],
      },
    },

    {
      path: '/transaction/withdraw',
      name: 'transaction-withdraw',
      component: () => import('@/views/Transaction/Withdrawal.vue'),
      props: { type: "withdrawal" },
      meta: {
        pageTitle: 'Giao dịch',
        breadcrumb: [
          {
            text: 'Rút tiền',
            active: true,
          },
        ],
      },
    },
    
    {
      path: '/order',
      name: 'order',
      component: () => import('@/views/Transaction/Order.vue'),
      meta: {
        pageTitle: 'Đặt cược',
        breadcrumb: [
          {
            text: 'Danh sách',
            active: true,
          },
        ],
      },
    },

    {
      path: '/games',
      name: 'games',
      component: () => import('@/views/Games.vue'),
      meta: {
        pageTitle: 'Trò chơi',
        breadcrumb: [
          {
            text: 'game',
            active: true,
          },
        ],
      },
    },


    {
      path: '/products',
      name: 'products',
      component: () => import('@/views/Products.vue'),
      meta: {
        pageTitle: 'Danh sách trò chơi',
        breadcrumb: [
          {
            text: 'game',
            active: true,
          },
        ],
      },
    },

    {
      path: "/chat-manage",
      name: "chat-manage",
      component: () => import("@/views/ChatManage.vue"),
      meta: {
        pageTitle: "Quản lí chat",
        breadcrumb: [
          {
            text: "Danh sách",
            active: true,
          },
        ],
      },
    },
    
    // {
    //   path: '/settings',
    //   name: 'settings',
    //   component: () => import('@/views/Settings.vue'),
    //   meta: {
    //     pageTitle: 'Cài đặt',
    //     breadcrumb: [
    //       {
    //         text: 'settings',
    //         active: true,
    //       },
    //     ],
    //   },
    // },

    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = localStorage.getItem('accessToken')
  if (!to.meta.redirectIfLoggedIn && !isLoggedIn) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next({ name: 'home' })
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
